import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistSettingsDashboardQueryKeys } from "modules/ChecklistSettingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useCreateTemplateMutation = () =>
  useTypedMutation<string, number>({
    mutationFn: async name => (await ApiInstance.post("/checklists/template/create", { name }, ENV.dealerBaseURL)).data.id,
    onSuccess: (name, id) => {
      const templates = typedQueryClient.getQueryData(ChecklistSettingsDashboardQueryKeys.checklistTemplates);
      if (!templates) return;

      const template = { checklist_template_id: id, name, default_only: false };
      typedQueryClient.setQueryData(ChecklistSettingsDashboardQueryKeys.checklistTemplates, [template, ...templates]);
    }
  });
